/**
 * Safely extract a displayable error message from an Axios error.
 *
 * The backend SentryExceptionFilter may return `message` as a string,
 * an array of strings (NestJS validation), or the full exception
 * response object.  This helper normalises all cases to a plain string.
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (!err || typeof err !== 'object') return fallback;

  const axiosData = (err as any)?.response?.data;
  if (!axiosData) return (err as any)?.message ?? fallback;

  const raw = axiosData.message;

  if (typeof raw === 'string') return raw;
  if (Array.isArray(raw)) return raw.filter((m) => typeof m === 'string').join(', ') || fallback;
  if (typeof raw === 'object' && raw !== null && typeof raw.message === 'string') return raw.message;

  return fallback;
}
